var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gis-viewer',{ref:"gis-viewer"})
}
var staticRenderFns = []

export { render, staticRenderFns }